import { useMutation, useQueryClient } from "@tanstack/react-query";
import { unassignParcours } from "../api/membersApi";
import { queryKeys } from "../lib/queryKeys";
import type { AssignParcoursArgs } from "./useAssignParcours";

export function useUnassignParcours() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ memberId, parcoursId }: AssignParcoursArgs) => unassignParcours(memberId, parcoursId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.members.all });
    },
  });
}
